import { CaretLeftFill, CaretDownFill, DistributeVertical, DistributeHorizontal } from 'react-bootstrap-icons';
import { useState, Fragment, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { bitwiseAnd } from '../store/api/CommonFunctions';
import { useSelector } from 'react-redux';
const MenuItem = (props) => {
    const { title, items, level2, style, className, initHeight, subsysCode } = props;
    const [subMenuDisplay, setSubMenuDisplay] = useState(initHeight ?? "0");
    const { activeSS } = useSelector(state => { return { activeSS: state.SystemSettingsReducer.activeSubsystems?.Data } });
    const activeMenuList = activeSS?.MenuAccessNumber?.split?.('-');
    const menuClick = (e) => {
        let d = subMenuDisplay === "0" ? level2?"max-content":"500px" : "0";
        setSubMenuDisplay(d);
    }
    const checkSubsytem = useCallback(() => {
        if (activeMenuList?.length > 0) {
            for (var m in activeMenuList) {
                const menu = activeMenuList[m].split(',');
                if (!subsysCode || level2 || Number(menu[0]) === Number(subsysCode)) {
                    return true;
                }
            };
            return false;
        }
        return true;
    });
    const checkMenu = useCallback((item) => {
        if(!subsysCode)
        {
            return true;
        }
        let code = item.code;
        if (activeMenuList?.length > 0) {
            for (var m in activeMenuList) {
                const menu = activeMenuList[m].split(',');
                if (Number(menu[0]) === Number(subsysCode)) {
                    if (item.subItems && !code) {
                        for (var indx in item.subItems) {
                            const si = item.subItems[indx];
                            if (bitwiseAnd(Number(si.code), Number(menu[1])) === Number(si.code)) {
                                return true;
                            }
                        }
                        return false;
                    }
                    if (bitwiseAnd(Number(code), Number(menu[1])) === Number(code) /*Number(menu[1])*/) {
                        return true;
                    }
                }
            };
            return false;
        }
        return true;
    },[activeMenuList]);
    return (
        checkSubsytem() ?
            <div className={"menuItem" + (level2 ? " menuItemL2" : "") + (className ? " " + className : "")} >
                {level2 &&
                    <Fragment>
                        {subMenuDisplay === "0"? <CaretLeftFill />:
                         <CaretDownFill />}
                    </Fragment>
                }
                {!level2 &&
                    <Fragment>
                        {subMenuDisplay === "0"? <DistributeVertical color='#451a95' />:
                         <DistributeHorizontal color='#451a95' />}
                    </Fragment>
                }
                <span className={level2 ? "menuTitleL2" : 'menuTitle'} onClick={menuClick}>{title}</span>
                <div className='subMenu' style={{ ...style, marginTop: level2 ? "5px" : "10px", marginBottom: level2 ? "4px" : "8px", maxHeight: subMenuDisplay }}>
                    {items && items.map((item, i) => {
                        return (
                            (item.showCondition === undefined || item.showCondition(item)) && checkMenu(item) &&
                            <Fragment key={i}>
                                {item.type === "a" &&
                                    <a href={item.href} onClick={item.onClick} style={{ marginRight: "13px", marginTop: "2px", display: "block" }} className='menuLeaf'>
                                        {item.icon}
                                        <span style={{ color: "black", fontSize: "12px", marginRight: "8px" }}>{item.text}</span>
                                    </a>
                                }
                                {item.type === "link" &&
                                    <Link to={{ pathname: item.to, state: null }} onClick={item.onClick} style={{ marginRight: "13px", marginTop: "2px", display: "block", ...item.style }} className="menuLeaf">
                                        {item.icon}
                                        <span style={{ color: "black", fontSize: "12px", marginRight: "8px" }}>{item.text}</span>
                                    </Link>
                                }
                                {item.type === "space" &&
                                    <div style={{ width: "100%", height: "5px" }}>&nbsp;&nbsp;</div>
                                }
                                {item.type === "line" &&
                                    <div style={{ width: "100%", marginRight: "18px", marginTop: "2px" }}>---------------------------------</div>
                                }
                                {item.type === "menuItem" &&
                                    <MenuItem title={item.title} items={item.subItems} level2={true} style={item.style} className={item.className} subsysCode={subsysCode} />
                                }
                            </Fragment>)

                    })}
                </div>
            </div> : null)
}
export default MenuItem;